module.exports = __webpack_public_path__ + "img/d010_4.19f152a7.png";